
import aessModena from '../img/clientes/aess.jpg';
import renael from '../img/clientes/renael.png';
import uvempren from '../img/clientes/uvempren.png';
import reds from '../img/clientes/sdsn.png';
import hec from '../img/clientes/hec-paris-logo-png_seeklogo-65984.png';
import eit from '../img/clientes/Eit.jpg';
import climate from '../img/clientes/climatekic.png';
import jrc from '../img/clientes/eujointresearchcenter.jpg';
import ingenio from '../img/clientes/ingenio.png';


const clientesData = [
    {
        nombre: 'AESS Modena',
        logo: aessModena,
    },
    {
        nombre: 'RENAEL',
        logo: renael,
    },
    {
        nombre: 'UVemprén',
        logo: uvempren,
    },
    {
        nombre: 'Red Española para el desarrollo Sostenible',
        logo: reds,
    },
    {
        nombre: 'HEC Paris',
        logo: hec,
    },
    {
        nombre: 'EIT',
        logo: eit,
    },
    {
        nombre: 'Climate KIC',
        logo: climate,
    },
    {
        nombre: 'JRC',
        logo: jrc,
    },
    {
        nombre: 'INGENIO CSIC-UPV',
        logo: ingenio,
    },
];

export default clientesData;